import Vue from 'vue'
import Router from 'vue-router'

import Frontpage from '@/components/Frontpage'

import HouseMainPage from '../components/HouseMainPage'
import HouseResultPage from '../components/HouseResultPage'

import HouseStateTownDialog from '../components/dialog/HouseStateTownDialog'
import HouseRoofShapeDialog from '../components/dialog/HouseRoofShapeDialog'
import HouseDoorsDialog from '../components/dialog/HouseDoorsDialog'
import HouseWindowsDialog from '../components/dialog/HouseWindowsDialog'
import HouseFireplacesDialog from '../components/dialog/HouseFireplacesDialog'
import HouseFloorsDialog from '../components/dialog/HouseFloorsDialog'
import HouseLivingFloorDialog from '../components/dialog/HouseLivingFloorDialog'
import HouseShapeDialog from '../components/dialog/HouseShapeDialog'

import RoomMainPage from '../components/RoomMainPage'
import RoomResultPage from '../components/RoomResultPage'

import RoomShapeDialog from '../components/dialog/RoomShapeDialog'
import RoomStateTownDialog from '../components/dialog/RoomStateTownDialog'
import RoomAreaDialog from '../components/dialog/RoomAreaDialog'
import RoomHeightDialog from '../components/dialog/RoomHeightDialog'
import RoomWindowsDialog from '../components/dialog/RoomWindowsDialog'
import RoomDoorsDialog from '../components/dialog/RoomDoorsDialog'

import ParamsNotSetDialog from '../components/dialog/ParamsNotSetDialog'

Vue.use(Router)



let roomParams = {
  paikkakunta: RoomStateTownDialog,
  pohjamuoto: RoomShapeDialog,
  ala: RoomAreaDialog,
  korkeus: RoomHeightDialog,
  ikkunat: RoomWindowsDialog,
  valiovet: RoomDoorsDialog,
  kesken: ParamsNotSetDialog
}

let houseParams = {
  paikkakunta: HouseStateTownDialog,
  pohjamuoto: HouseShapeDialog,
  kerrokset: HouseFloorsDialog,
  asuinkerros: HouseLivingFloorDialog,
  kattomuoto: HouseRoofShapeDialog,
  ovet: HouseDoorsDialog,
  ikkunat: HouseWindowsDialog,
  tulisijat: HouseFireplacesDialog,
  kesken: ParamsNotSetDialog
}



let router = new Router({
  mode: 'history',
  base: '/laskuri/ui/',

  scrollBehavior (to, from, savedPosition) {
    if (to.matched.some(m => m.meta.popup) || from.matched.some(m => m.meta.popup)) {
      // don't reset scroll when navigating to/from popup
      return savedPosition
    }
    return { x: 0, y: 0 }
  },

  routes: [
    {
      path: '/',
      name: 'frontpage',
      component: Frontpage
    },

    /* start house related */

    {
      path: '/talo/:calculationId',
      name: 'talo',
      component: HouseMainPage,
      props: true
    },

    ...Object.entries(houseParams).map(e => ({
      path: '/talo/:calculationId/' + e[0],
      props: {
        default: true
      },
      meta: {
        popup: true
      },
      components: {
        default: HouseMainPage,
        popup: e[1]
      }
    })),

    {
      path: '/talo/:calculationId/tulos',
      component: HouseResultPage,
      props: route => ({
        calculationId: route.params.calculationId,
        operationId: route.params.id
      })
    },

    /* start room related */
    {
      path: '/tila/:calculationId',
      name: 'tila',
      component: RoomMainPage,
      props: true
    },

    ...Object.entries(roomParams).map(e => ({
      path: '/tila/:calculationId/' + e[0],
      props: {
        default: true
      },
      meta: {
        popup: true
      },
      components: {
        default: RoomMainPage,
        popup: e[1]
      }
    })),

    {
      path: '/tila/:calculationId/tulos',
      component: RoomResultPage,
      props: route => ({
        calculationId: route.params.calculationId,
        operationId: route.params.id
      })
    }
  ]
})

router.beforeEach((to, from, next) => {
  // This will hide and dispose any dialogs that might be left open
  //   (this can happen when leaving from dialog with browsers back-button)
  $('.modal').off('hidden.bs.modal')
    .modal('hide')
    .modal('dispose')

  next()
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js